import { getFiGrowthBook } from '../lib/growthbook';

/**
 * Apple pay / google pay buttons above the v2 checkout form, behind 'ecom-express-wallets-top'.
 * Off, the wallets live only in the payment accordion.
 */
export default function useExpressWalletsTop(): boolean {
  return getFiGrowthBook().getFeatureValue<boolean>('ecom-express-wallets-top', false);
}
